export default __webpack_public_path__ + "static/media/Savage Death Belt.5dd2b791.jpg";